import sanitizeHtml from 'sanitize-html';

const SANITIZE_OPTIONS = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'iframe']),
  allowedSchemes: ['data', 'http', 'https'],
  allowedClasses: { '*': ['ql-*'] },
  allowedAttributes: {
    a: ['href', 'name', 'target'],
    img: ['src'],
    '*': ['style'],
    iframe: ['src', 'frameborder', 'allowfullscreen', 'height', 'width'],
  },
  allowedIframeHostnames: ['www.youtube.com', 'player.vimeo.com'],
  allowedSchemesAppliedToAttributes: ['href', 'src'],
};

export default SANITIZE_OPTIONS;
